function init_girls_clip_anim(main,from_php,animCanvas2,state){
//            $.goToLocation("girls/"+from_php.girl.girl_id+"/",{newGirlLevel:1});
    main.find("#showNextGirlLevelJS").bookUse("show");
    var load_images={
        "clip_up":""+_IMG_SERV+"/gfx/place/girls/newlevel/clip_up.png",
        "clip_bottom":""+_IMG_SERV+"/gfx/place/girls/newlevel/clip_bottom.png",
        "nl_back":""+_IMG_SERV+"/gfx/place/girls/newlevel/back.png",
        "nl_heart":""+_IMG_SERV+"/gfx/place/girls/newlevel/heart.png",
        "nl_line_big":""+_IMG_SERV+"/gfx/place/girls/newlevel/line_big.png",
        "nl_line_left":""+_IMG_SERV+"/gfx/place/girls/newlevel/line_left.png",
        "nl_line_right":""+_IMG_SERV+"/gfx/place/girls/newlevel/line_right.png",
        
    };
    var imageAll={};
    function prepareImages(){
        var i;
        for(i in load_images){
            imageAll[i]=new Image();
            imageAll[i].src=load_images[i];
        }
    }
    var objMain=main.find("#girlNewLevel");
    var ctx=objMain[0];
    ctx=ctx.getContext("2d");
    var ctx_width=objMain.width(),ctx_height=objMain.height();
    var anim_index=_moduleTimeHandler.getNewIndex(),queue_index=_moduleTimeHandler.getNewIndex();
    
    function clipAnim(){
        
        
        ctx.restore();
        ctx.save();
        ctx.translate(-80,10);//image position
        
       
        
        var sceneVal=(from_php.girl.level+2);
        if(state!="before"){
            sceneVal=(from_php.girl.level+1);
        }
        if(sceneVal<10){
            sceneVal="0"+sceneVal;
        }
        var text_arr=[from_php.girl_stat.name,from_php.place_name,"SCENE "+sceneVal],i;
        
        
        
        var text_size_arr=[];
        var line_height=110;
        for(i in text_arr){
            text_size_arr.push(ctx.measureText(text_arr[i]).width);
        }

        function drawScene(scale,clip_deg){
            ctx.clearRect(-100, -100,ctx_width+100, ctx_height+100);
            ctx.save();
            ctx.scale(scale,scale);


//                    drawRotatedImage(ctx,imageAll["clip_up"],ctx_width/2/scale+20,ctx_height/2/scale-190,-20);
//                    drawRotatedImageByPoint(ctx,imageAll["clip_up"],ctx_width/2/scale,ctx_height/2/scale-390,-0,[39,129]);
//                    drawRotatedImageByPoint(ctx,imageAll["clip_up"],ctx_width/2/scale,ctx_height/2/scale-390,-90,[39,129])

            drawRotatedImageByPoint(ctx,imageAll["clip_up"],ctx_width/2/scale+17,ctx_height/2/scale-155,clip_deg,[33,106]);
            drawImage(ctx,imageAll["clip_bottom"],ctx_width/2/scale,ctx_height/2/scale);
            for(i=0;i<3;i++){
                ctx.strokeText(text_arr[i],(ctx_width-text_size_arr[i]*scale)/2/scale, (ctx_height+line_height*i*scale)/2/scale);
                ctx.fillText( text_arr[i],(ctx_width-text_size_arr[i]*scale)/2/scale, (ctx_height+line_height*i*scale)/2/scale);
            }
            ctx.restore();
        }
        drawScene(1,-25);

        if(state!="before"){
            _moduleTimeHandler.queueAdd(queue_index,function(){
                //clip
                _mySound.playSound("new_level_film");
                var step=0,a=0.7,v=1.8,
                deg_start=-25,deg;
                _moduleTimeHandler.set(anim_index,function(){
                    step++;
                    deg=deg_start+v*step+1/2*a*step*step;

                    if(deg>=0){
                        deg=0;
                    }
                    drawScene(1,deg);

                    if(deg==0){
                        _moduleTimeHandler.clear(anim_index);
                        _moduleTimeHandler.queueTrigger(queue_index);
                    }
                },40);

            });
            _moduleTimeHandler.queueAdd(queue_index,function(){
                 var t=0,t_max,v_arr=[18,10,6],g=1.7,v_index=-1;
                _moduleTimeHandler.set(anim_index,function(){

                    if(t==0){
                        v_index++;
                        if(typeof v_arr[v_index]!="undefined"){
                            t_max=2*v_arr[v_index]/g;
                        }
                        else{
                            _moduleTimeHandler.clear(anim_index);
                            return false;
                        }
                    }
                    var top=v_arr[v_index]*t-g*t*t/2;
                    t+=2;
                    if(t>=t_max){
                        t=0;
                    }
                    ctx.save();
                    ctx.translate(0,top);
                    drawScene(1,0);
                    ctx.restore();
                    return true;

                },40,function(){
                    _moduleTimeHandler.queueTrigger(queue_index);
                });

            });
            _moduleTimeHandler.queueAdd(queue_index,function(){
                //fadeout
                var step=0,step_max=90;
                _moduleTimeHandler.set(anim_index,function(){
                    step+=6;
                    drawScene(1-step/100,0);

                    if(step>=step_max){
                        _moduleTimeHandler.clear(anim_index);
                        objMain.fadeOut(200);
                        _moduleTimeHandler.setOne(anim_index,function(){
                            _moduleTimeHandler.queueTrigger(queue_index);
                        },200);
                    }
                },40);
            });
            _moduleTimeHandler.queueAdd(queue_index,function(){
                _moduleEvents.trigger("girlAnimEnd");
            });
            
        }
    }
    
    
    var load_images={
        "clip_up":""+_IMG_SERV+"/gfx/place/girls/newlevel/clip_up.png",
        "clip_bottom":""+_IMG_SERV+"/gfx/place/girls/newlevel/clip_bottom.png",
        "nl_back":""+_IMG_SERV+"/gfx/place/girls/newlevel/back.png",
        "nl_heart":""+_IMG_SERV+"/gfx/place/girls/newlevel/heart.png",
        "nl_line_big":""+_IMG_SERV+"/gfx/place/girls/newlevel/line_big.png",
        "nl_line_left":""+_IMG_SERV+"/gfx/place/girls/newlevel/line_left.png",
        "nl_line_right":""+_IMG_SERV+"/gfx/place/girls/newlevel/line_right.png",
        
    };
    
    function levelAnim(){
        main.find("#girlTrigger").trigger("click","newlevel");
        ctx.restore();
        ctx.save();
        ctx.translate(-80,10);//image position
        
        var arr_conf={
          "nl_line_left":{start:[-170,20],end:[-10,300]},
          "nl_line_right":{start:[170,20],end:[ctx_width+140,300]},
          "nl_line_big":{start:[0,110],end:[ctx_width/2,ctx_height+100]},
        };
        var text=from_php.langs.new_girl,text_width=ctx.measureText(text).width,line_height=30;
        function drawScene(scale){
            ctx.clearRect(-100, -100,ctx_width+100, ctx_height+100);
            

            drawImage(ctx,imageAll["nl_back"],ctx_width/2,ctx_height/2);
            ctx.save();
            ctx.scale(scale,scale);
            drawImage(ctx,imageAll["nl_heart"],ctx_width/2/scale,ctx_height/2/scale);
            ctx.restore();
            var bum,key,last;
            for(key in arr_conf){
                bum=arr_conf[key];
                drawImage(ctx,imageAll[key],ctx_width/2+bum.start[0],ctx_height/2+bum.start[1]);
            }
            ctx.strokeText(text,(ctx_width-text_width)/2, ctx_height/2+bum.start[1]-line_height);
            ctx.fillText( text,(ctx_width-text_width)/2, ctx_height/2+bum.start[1]-line_height);
            
            
        }
        var step_max_scale=0,step_max=0;
        function drawSceneMove(step,end){
            ctx.clearRect(-100, -100,ctx_width+300, ctx_height+100);
            drawManyHearts();
            if(step<25){
                ctx.save();
                drawImage(ctx,imageAll["nl_back"],ctx_width/2,ctx_height/2);
                var scale=1+step/100;
                step_max=step;
                step_max_scale=Math.max(scale,step_max_scale);
                ctx.scale(scale,scale);
                drawImage(ctx,imageAll["nl_heart"],ctx_width/2/scale,ctx_height/2/scale);
                ctx.restore();
            }
            else if(!end){
                ctx.save();
               
                
                var scale=step_max_scale;
                ctx.globalAlpha   = step_max/step;
                drawImage(ctx,imageAll["nl_back"],ctx_width/2,ctx_height/2);
                ctx.scale(scale,scale);
                drawImage(ctx,imageAll["nl_heart"],ctx_width/2/scale,ctx_height/2/scale);
                ctx.restore();
                
            }
            
            var key,bum,vec;
            for(key in arr_conf){
                bum=arr_conf[key];
                vec=bum.fun(step/100);
                drawImage(ctx,imageAll[key],vec[0],vec[1]);
            }
            ctx.strokeText(text,(ctx_width-text_width)/2, vec[1]-line_height);
            ctx.fillText( text,(ctx_width-text_width)/2, vec[1]-line_height);
        }
        var start_draw=0;
        function drawManyHearts(){
            if(start_draw){
                return false;
            }
            start_draw=1;
            var i,k,step=0,step_max=10,q_index=_moduleTimeHandler.getNewIndex();
            var cent=[ctx_width/2-80,ctx_height/2+10];
            _moduleTimeHandler.set(q_index,function(){
                step++;
                for(i=-40;i<=40;i+=60){
                    for(k=-40;k<=40;k+=60){
                        animCanvas2.startGirlAnim("addAnimLines",[cent[0]+i+mt_rand(-2,2),cent[1]+k+mt_rand(-2,2)]);
                    }
                    
                }
                if(step>=step_max){
                    _moduleTimeHandler.clear(q_index);
                    _moduleTimeHandler.addOne(function(){
                         _moduleEvents.trigger("dialogSexNew");
                    },2500);
                }
            },80);
            
        }
        drawScene(1);
        if(state!="before"){
            _moduleTimeHandler.queueAdd(queue_index,function(){

                $(".place.girls").removeClass("opacity");

                var dir=1,step_min=80,state=100,period=1,period_max=12;
                _moduleTimeHandler.set(anim_index,function(){
                    state+=dir;
                    if(state>=100){
                        period++;
                        dir=-period;
                        state=100;
                    }
                    if(state<=step_min){
                        state=step_min;
                        period++;
                        dir=period;
                    }
                     drawScene(state/100);
                    if(period>=period_max){
                        _moduleTimeHandler.clear(anim_index);
                        _moduleTimeHandler.queueTrigger(queue_index);
                    }
                },40);
            });
            _moduleTimeHandler.queueAdd(queue_index,function(){
                var key,bum;
                for(key in arr_conf){
                    bum=arr_conf[key];
                    arr_conf[key].fun=new Smooth([[bum.start[0]+ctx_width/2,bum.start[1]+ctx_height/2],bum.end]);
                }
                var step=0,range,range_max=100,v=2,a=0.3,end=0;
                _moduleTimeHandler.set(anim_index,function(){
                    step++;
                    range=step*v+1/2*a*step*step;

                    if(range>=range_max){
                        range=range_max;
                        end=1;
                    }
                    drawSceneMove(range,end);
                    if(range>=range_max){
                        _moduleTimeHandler.clear(anim_index);
                    }

                },40);
            });
        }
    }
    
    
    $("<div/>").one("myload",function(){
        prepareImages();
        
        ctx.textAlign = 'left';
        ctx.fillStyle = '#ffffff';
        ctx.lineWidth = 12;
        ctx.font = '40px Montserrat';
        
        
        if((from_php.girl.level>=9 && state=="before") || from_php.girl.level>=10){
             ctx.font = '40px Montserrat';
            ctx.strokeStyle="#69371A";
            levelAnim();
        }
        else{
            ctx.strokeStyle="#1E1E1E";
            clipAnim();
        }
       
       
        

        if(state=="before"){
            _moduleTimeHandler.queueAdd(queue_index,function(){
            //end anim!
                $.goToLocation("girls/"+from_php.girl.girl_id+"/",{newGirlLevel:1});
            });
            $("#butGirl").off("click.bg").one("click.bg",function(){
                objMain.trigger("click");
            });
            
            objMain.off("click.gnewl").one("click.gnewl",function(){
                _moduleTimeHandler.queueTrigger(queue_index);
            });
        }
        else{
            _moduleTimeHandler.queueTrigger(queue_index);
        }
        
        

    }).myLoad(load_images);
            
            
            
            
}

